// Texty výpisu rubriky blogu (articlesPage.js).
export default {
  lead: 'Nejnovější',
  leadCta: 'Přečíst článek',
  more: 'Číst dál',
  rubrics: 'Rubriky',
  latest: 'Nejnovější v rubrice',
  prev: 'Předchozí strana',
  next: 'Další strana',
  pagerLabel: 'Stránkování článků',
  /** „Strana 2 z 6" */
  pageOf: (page, pages) => 'Strana ' + page + ' z ' + pages,
  newsletterEyebrow: 'Newsletter',
  newsletterTitle: 'Tipy do dílny jednou měsíčně',
  newsletterText: 'Nové články, sezónní rady a akce dřív než na webu. Odhlásíte se jedním klikem.',
  newsletterCta: 'Odebírat novinky',
  newsletterSubmit: 'Odebírat',
  newsletterPlaceholder: 'vas@email.cz',
  newsletterLabel: 'Váš e-mail',
};
